import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { KYMW00Model } from './commons/kymw00/kymw00.model';
import { CachedUrl } from './shared/http/cached-url.service';

export const authGuard: CanActivateFn = (route, state) => {
  const sharedModel = inject(KYMW00Model);
  const router = inject(Router);
  const cachedUrl = inject(CachedUrl);

  const opener = window?.opener;
  if (
    opener &&
    opener.location.origin === window.location.origin &&
    '/subwindow' + opener.location.pathname === window.location.pathname
  )
    return true;

  // TODO: 要確認
  // return true;
  // KYMW00Model.kymw1001Model.loginUserInfoがあった場合、ログイン済みと判断する
  if (sharedModel.kymw1001Model.loginUserInfo?.UserID) {
    return true;
  } else {
    cachedUrl.url = state.url;
    router.navigate(['/auth']);
    return false;
  }
};
